import { useState } from 'react'
import { useAppSelector } from '../../../hooks/redux'
import { Colors } from '../../../constants/Colors'
import style from './PrevNext.module.css'

interface Props {
    icon: string,
    disabled: boolean,
    onClick: () => void
}

const PrevNextButton = ({
        icon,
        disabled,
        onClick
    }: Props
) => {

    const theme = useAppSelector<string>(state => state.theme.theme)

    const [isHover, setIsHover] = useState<boolean>(false)

    const handleMouseEnter = () => {
        setIsHover(true)
    }

    const handleMouseLeave = () => {
        setIsHover(false)
    }

    return (
        <button
            className={style.button}
            style={
                disabled
                    ? {
                        color: Colors[theme ?? 'light'].activeTint,
                        backgroundColor: Colors[theme ?? 'light'].disabled
                    }
                : isHover
                ? {
                    border: `1px solid ${Colors[theme ?? 'light'].app}`,
                    color: Colors[theme ?? 'light'].app,
                    backgroundColor: Colors[theme ?? 'light'].white
                }
                : {
                    color: Colors[theme ?? 'light'].activeTint,
                    backgroundColor: Colors[theme ?? 'light'].app
                }
            }
            onClick={onClick}
            disabled={disabled}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <i className={icon}></i>
        </button>
    )
}

export default PrevNextButton